var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow- back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9512 10.5545C18.9512 5.61477 14.9326 1.59619 9.99284 1.59619C7.72592 1.59619 5.59192 2.44944 3.95117 3.95594V2.22119C3.95117 1.87611 3.67126 1.59619 3.32617 1.59619C2.98109 1.59619 2.70117 1.87611 2.70117 2.22119V5.55053C2.70117 5.55194 2.70034 5.55311 2.70034 5.55452C2.70034 5.89961 2.98026 6.17952 3.32534 6.17952H6.65951C7.00459 6.17952 7.28451 5.89961 7.28451 5.55452C7.28451 5.20944 7.00459 4.92952 6.65951 4.92952H4.73409C6.15401 3.59936 8.01542 2.84619 9.99284 2.84619C14.2433 2.84619 17.7012 6.30403 17.7012 10.5545C17.7012 14.805 14.2433 18.2629 9.99284 18.2629C5.74234 18.2629 2.28451 14.805 2.28451 10.5545C2.28451 10.2094 2.00459 9.92953 1.65951 9.92953C1.31442 9.92953 1.03451 10.2094 1.03451 10.5545C1.03451 15.4943 5.05309 19.5129 9.99284 19.5129C14.9326 19.5129 18.9512 15.4943 18.9512 10.5545Z",
    fill: "#213A51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.bb8368a634df9383b60ca668f801e61c.svg";
export { ForwardRef as ReactComponent };